const produtosMock = [
  {
    produto_id: '1',
    nome: 'Apple iPhone 15 128GB - Ultrarroxo',
    preco: 5100,
    origem: 'Amazon',
    src: 'caminho/para/imagem_iphone.jpg',
    categoria: 'Smartphone',
  },
  {
    produto_id: '2',
    nome: 'Smartwatch Samsung Galaxy Watch7 44mm',
    preco: 1304.10,
    origem: 'Magalu',
    src: 'caminho/para/imagem_watch.jpg',
    categoria: 'Smartwatch',
  },
  {
    produto_id: '3',
    nome: 'Notebook Samsung Galaxy Book4 Intel® Core™ i5-1335U',
    preco: 4679.90,
    origem: 'Mercado Livre',
    src: 'caminho/para/imagem_notebook.jpg',
    categoria: 'Notebook',
  },
  {
    produto_id: '4',
    nome: 'Cabo Usb-C Lightning + Fonte Carregador 25W',
    preco: 58.59,
    origem: 'Amazon',
    src: 'caminho/para/imagem_cabo_usb.jpg',
    categoria: 'Acessórios',
  },
  {
    produto_id: '5',
    nome: 'GShield Capa Ergonômica para Notebook de até 15.6”',
    preco: 159.99,
    origem: 'Amazon',
    src: 'caminho/para/imagem_capa_notebook.jpg',
    categoria: 'Acessórios',
  },
  {
    produto_id: '6',
    nome: 'Mouse Sem Fio Recarregável Ergonômico, RGB',
    preco: 28.40,
    origem: 'Magalu',
    src: 'caminho/para/imagem_mouse.jpg',
    categoria: 'Outros',
  },
  {
    produto_id: '7',
    nome: 'Havit Fone de Ouvido Headset Gamer Fuxi-H3',
    preco: 199.00,
    origem: 'Mercado Livre',
    src: 'caminho/para/imagem_fone.jpg',
    categoria: 'Outros',
  },
  {
    produto_id: '8',
    nome: 'Armazém Brasil, Monitor Portátil 15.6”, FHD 1080P',
    preco: 512.99,
    origem: 'Amazon',
    src: 'caminho/para/imagem_monitor_portatil.jpg',
    categoria: 'Outros',
  },
  {
    produto_id: '9',
    nome: 'ARZOPA Monitor portátil de 17.3”, monitor para jogos IPS',
    preco: 863.59,
    origem: 'Amazon',
    src: 'caminho/para/imagem_monitor_arzopa.jpg',
    categoria: 'Outros',
  },
  {
    produto_id: '10',
    nome: 'Monitor AOC DESTINY 25” 240Hz 0.5ms',
    preco: 1139.90,
    origem: 'Mercado Livre',
    src: 'caminho/para/imagem_monitor_aoc.jpg',
    categoria: 'Outros',
  },
  {
    produto_id: '11',
    nome: 'Smartphone Samsung Galaxy A55 5G 128GB',
    preco: 1969.00,
    origem: 'Magalu',
    src: 'caminho/para/imagem_galaxy_a55.jpg',
    categoria: 'Smartphone',
  },
  {
    produto_id: '12',
    nome: 'Cabo Gshield Tipo C (iPhone/iPad) Carregamento Rápido',
    preco: 97.61,
    origem: 'Amazon',
    src: 'caminho/para/imagem_cabo_gshield.jpg',
    categoria: 'Acessórios',
  },
];

export default produtosMock;